import { createClient, errorExchange, subscriptionExchange } from "urql";
import { cacheExchange } from "@urql/exchange-graphcache";
import { devtoolsExchange } from "@urql/devtools";
import settings from "../config/settings";
import { createClient as createWS } from "graphql-ws";
import { refreshToken } from "./utils";
import {
  notificationsQuery,
  notificationSubscription,
  txNotificationsQuery,
  txNotificationSubscription,
} from "./mutations";
import { TRADES_QUERY } from "../graphql/queries";
const localStorage = window.localStorage;

export const getAccessToken = () => localStorage.getItem("token");
export const setAccessToken = (token) => localStorage.setItem("token", token);
export const clearAccessToken = () => localStorage.removeItem("token");
export const getRefreshToken = () => localStorage.getItem("refreshToken");
export const setRefreshToken = (refreshToken) =>
  localStorage.setItem("refreshToken", refreshToken);
export const clearRefreshToken = () => localStorage.removeItem("refreshToken");

export const gqlWs = createWS({
  url: settings.apiUrl.replace("http", "ws"),
  lazy: false,
  connectionParams: async () => {
    let token = await refreshToken();
    return { authorization: "Bearer " + token };
  },
});
export const gqlWsFree = createWS({
  url: settings.apiUrl.replace("http", "ws"),
  lazy: false,
});

const didAuthError = (error) => {
  return error.graphQLErrors.some((e) => e.message === "unauthorized");
};

export const client = (handleAuthFail) => {
  return createClient({
    url: `${settings.apiUrl}`,
    exchanges: [
      devtoolsExchange,
      cacheExchange({
        keys: {
          Token: (token) => token.address,
          TokenApproval: (approval) => null,
          Signature: () => null,
          Methods: () => null,
          ContractFile: () => null,
          Pair: (pair) => pair.address,
          Candle: () => null,
          NameTag: (nameTag) => nameTag.id,
          Network: (net) => net.id,
          Keyword: (k) => null,
          Transaction: (tx) => tx.hash,
          Notification: (n) => n.id,
          NotificationSetting: (n) => n.id,
          Trade: (t) => t.transactionHash,
        },
        updates: {
          Subscription: {
            tokenEvents(result, _args, cache, _info) {
              cache.updateQuery(
                {
                  query: tokensQuery,
                  variables: {
                    page: { first: 25, after: "" },
                    filter: _args?.filter,
                  },
                },
                (data) => {
                  if (data)
                    return {
                      tokens: {
                        ...data.tokens,
                        edges: [
                          {
                            node: {
                              ...result.tokenEvents.token,
                            },
                            __typename: "TokenEdge",
                          },
                          ...data.tokens?.edges,
                        ],
                      },
                    };
                }
              );

              if (result.tokenEvents.token.contractState === "PENDING")
                cache.updateQuery(
                  {
                    query: tokensQuery,
                    variables: {
                      page: { first: 25, after: "" },
                      filter: { ..._args?.filter, contractState: "PENDING" },
                    },
                  },
                  (data) => {
                    if (data)
                      return {
                        tokens: {
                          ...data.tokens,
                          edges: [
                            {
                              node: {
                                ...result.tokenEvents.token,
                              },
                              __typename: "TokenEdge",
                            },
                            ...data.tokens?.edges,
                          ],
                        },
                      };
                  }
                );

              if (
                result.tokenEvents.token.contractState === "CONFIRMED" ||
                result.tokenEvents.token.contractState === "CODE_VERIFIED"
              )
                cache.updateQuery(
                  {
                    query: tokensQuery,
                    variables: {
                      page: {
                        first: 25,
                        after: "",
                      },
                      filter: {
                        ..._args?.filter,
                        contractState: "PENDING",
                        marketState: _args.marketState,
                      },
                    },
                  },
                  (data) => {
                    if (data) {
                      return {
                        tokens: {
                          edges: data.tokens.edges.filter(
                            (el) =>
                              el.node.address !==
                              result.tokenEvents.token.address
                          ),
                        },
                      };
                    }
                  }
                );
            },
            tokenApprovals(result, _args, cache, _info) {
              cache.updateQuery(
                {
                  query: tokenApprovalsQuery,
                  variables: {
                    page: { first: 25, after: "" },
                    filter: _args?.filter,
                  },
                },
                (data) => {
                  if (data) {
                    return {
                      tokenApprovals: {
                        ...data.tokenApprovals,
                        edges: [
                          {
                            node: {
                              ...result.tokenApprovals,
                            },
                            __typename: "TokenApprovalEdge",
                          },
                          ...data.tokenApprovals?.edges,
                        ],
                      },
                    };
                  }
                }
              );
            },
            // notifications(result, _args, cache, _info) {
            //   const data = cache.readQuery({
            //     query: notificationsQuery,
            //     variables: {
            //       page: {
            //         first: 10,
            //       },
            //       filter: {
            //         networkId: _args.networkId,
            //       },
            //     },
            //   });
            //   return {
            //     notifications: {
            //       ...data.notifications,
            //       edges: [
            //         ...data.notifications?.edges,
            //         ...result.notifications?.edges,
            //       ],
            //     },
            //   };
            // },
            // trades(result, _args, cache, _info) {
            //   console.log("trades", _args, result);
            //   cache.updateQuery(
            //     {
            //       query: TRADES_QUERY,
            //       variables: {
            //         pageArgs: { first: 25, after: "" },
            //         filter: { ..._args.filter, networkId: 1, pair: _args.pair },
            //       },
            //     },
            //     (data) => {
            //       if (data) {
            //         return {
            //           trades: {
            //             ...data.trades,
            //             edges: [
            //               {
            //                 node: {
            //                   ...result.trades,
            //                 },
            //                 __typename: "TradeEdge",
            //               },
            //               ...data.trades.edges,
            //             ],
            //           },
            //         };
            //       }
            //       return data;
            //     }
            //   );
            // },
          },
        },
      }),
      errorExchange({
        onError: (error) => {
          if (didAuthError(error)) {
            handleAuthFail();
          }
        },
      }),
      subscriptionExchange({
        enableAllOperations: true,
        forwardSubscription: (operation) => {
          //Unauthenticated websocket
          if (operation.variables?.input?.hash) {
            return {
              subscribe: (sink) => ({
                unsubscribe: gqlWsFree.subscribe(operation, sink),
              }),
            };
          }
          return {
            subscribe: (sink) => ({
              unsubscribe: gqlWs.subscribe(operation, sink),
            }),
          };
        },
      }),
    ],
  });
};
